import {AriaDatePickerProps, DateValue, useDatePicker} from 'react-aria';
import {DatePickerStateOptions, useDatePickerState} from 'react-stately';
import React, {useRef} from "react";
import {Calendar} from "./Calendar";
import {DateField} from "./DateField";
import {Popover} from "./Popover";
import {Dialog} from "./Dialog";
import {CalendarIcon} from "@heroicons/react/24/outline";
import {FieldButton} from "./DateRangePicker";
import {InputSetToNull} from "./Icons";

export function DatePicker(props: DatePickerStateOptions<DateValue> | AriaDatePickerProps<DateValue>) {

    const {label, isRequired, isDisabled} = props;
    const state = useDatePickerState(props);
    const ref = useRef(null);
    const {
        groupProps,
        labelProps,
        fieldProps,
        buttonProps,
        dialogProps,
        calendarProps,
        descriptionProps
    } = useDatePicker(props, state, ref);

    return (
        <div>
            {label && (
                <div {...labelProps} className={'field-label'}>
                    {label}
                    {isRequired && <span className={'field-required'}>*</span>}
                </div>
            )}

            <div {...groupProps} ref={ref} className={`field-container justify-between ${isDisabled ? 'field-disabled' : ''}`}>
                <DateField {...fieldProps} />
                <div className="flex items-center space-x-1 mr-1">

                    {/* Reset Button */}
                    {!isDisabled && state.value && (
                        <FieldButton onPress={() => state.setValue(null)} aria-label="Reset date">
                            <InputSetToNull className="text-gray-700 w-3.5 h-3.5"/>
                        </FieldButton>
                    )}

                    {/* Calendar Button */}
                    <FieldButton {...buttonProps} isPressed={state.isOpen}>
                        <CalendarIcon className="w-5 h-5 text-gray-700" />
                    </FieldButton>
                </div>
            </div>

            {props.description && (
                <div {...descriptionProps} className={'mt-2 text-xs'}>
                    {props.description}
                </div>
            )}

            {state.isOpen &&
                (
                    <Popover state={state} triggerRef={ref} placement="bottom start" className={'p-4'}>
                        <Dialog {...dialogProps}>
                            <Calendar {...calendarProps} firstDayOfWeek={props.firstDayOfWeek}/>
                        </Dialog>
                    </Popover>
                )}
        </div>
    );
}